import OfficeDistrictApi from 'services/api/OfficeDistrictApi';

/* Service class used to perform api calls for offices */
class DistrictsService {

    constructor() {
        this.api = OfficeDistrictApi.create();
    }

    /**
     * Retrieves a list of offices with return counts for the districts that belong
     * to the user (must be DM or DoC to get valid results)
     * @param {any} sort
     * @param {any} reversed
     * @param {any} limit
     * @param {any} offset
     */
    async getDistrictOfficesList(sort, reversed, limit, offset, districtIdFilter) {
        let officeList = null
        try {
            let response = await this.api.getDistrictOfficesList(sort, reversed, limit, offset, districtIdFilter);
            if (response && response.status === 200) {
                officeList = response.data
            } else {
                officeList =  { error_code: response.status }
            }
        } catch (ex) {
            console.log(ex)
        }

        return officeList
    }

    async getDistricts() {
        let districtList = null
        try {
            let response = await this.api.getDistricts();
            if (response && response.status === 200) {
                districtList = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return districtList
    }
}

const districtsService = new DistrictsService();
export default districtsService;